import React from 'react';
import { createContext } from 'use-context-selector';
import { useAuth } from '@auth-wrapper';
import { completeSimulation as completeSimulationAPI } from '@services/scenarios-simulator';

interface CompleteSimulationContextData {
  isSimulationCompletedWithSuccess: boolean;
  isLoadingCompleteSimulation: boolean;
  completeSimulation: (simulation_id: string) => Promise<any>;
}

export const CompleteSimulationContext = createContext({} as CompleteSimulationContextData);

interface Provider {
  children: React.ReactNode;
}

const CompleteSimulationProvider: React.FC<Provider> = ({ children }) => {
  const {
    authStatus: { accessToken: token },
  } = useAuth();

  const [isSimulationCompletedWithSuccess, setIsSimulationCompletedWithSuccess] = React.useState<boolean>(false);
  const [isLoadingCompleteSimulation, setIsLoadingCompleteSimulation] = React.useState<boolean>(false);

  const completeSimulation = React.useCallback(
    async (simulation_id: string): Promise<any> => {
      if (!token) {
        notifyError('No authentication token available');
        return;
      }

      setIsLoadingCompleteSimulation(true);
      try {
        const success = await completeSimulationAPI(simulation_id, token);
        setIsSimulationCompletedWithSuccess(success);
        return success;
      } finally {
        setIsLoadingCompleteSimulation(false);
      }
    },
    [token],
  );

  return (
    <CompleteSimulationContext.Provider
      value={{
        completeSimulation,
        isLoadingCompleteSimulation,
        isSimulationCompletedWithSuccess,
      }}
    >
      {children}
    </CompleteSimulationContext.Provider>
  );
};

export default CompleteSimulationProvider;
